import { render, staticRenderFns } from "./formEditConference-comp.vue?vue&type=template&id=31d9961e&"
import script from "./formEditConference-comp.vue?vue&type=script&lang=js&"
export * from "./formEditConference-comp.vue?vue&type=script&lang=js&"
import style0 from "./formEditConference-comp.vue?vue&type=style&index=0&id=31d9961e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports